// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import Konami from "konami";
import "./App.css";
import "./fonts.css";
import "./iterations.css";
import useToken from "classes/Accounts/hooks/useToken";
import ForgetPage from "Pages/Login/ForgetPage/ForgetPage";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import BrainWrapper from "components/BrainWrapper/Wrapper";
import { ToastContainer } from "react-toastify";
import "react-confirm-alert/src/react-confirm-alert.css";
import "react-toastify/dist/ReactToastify.min.css";
import LoginPage from "Pages/Login/LoginPage";
import ResetPasswordPage from "Pages/Login/ResetPage/ResetPasswordPage";
import Storage from "classes/Storage/Storage";
// import useMenu from "hooks/useMenu";
import useAccount from "classes/Accounts/hooks/useAccount";
import ReactModal from "react-modal";
import useEditing from "components/EditDrawer/useEditing";
import { AccountProvider } from "providers/AccountProvider";
import { FilterProvider } from "providers/FilterProvider";
import { PostProvider } from "providers/PostProvider";
import { installationPrompt } from "components-v2/PWA/pwaPrompt.component";
import { manualPrompt } from "components-v2/PWA/pwaManualPrompt.component";
import "components-v2/PWA/pwaCheck.styles.css";
import {
	APP_INSTALLED,
	BEFORE_INSTALL_PROMPT,
	INSTALLATION_MESSAGE,
	INSTALLATION_STATUS,
	getDeviceInfo,
} from "includes/pwa_helpers";
import { UAParser } from "ua-parser-js";
import OneSignal from "react-onesignal";
import { RedirectNotifs } from "includes/redirectNotif";
import useMondayPwaTracker from "hooks/useMondayPwaTracker";
import genRequest from "includes/request";
// import CreatePage from "Pages/Create/Create";

// eslint-disable-next-line
const easterEgg = new Konami("https://shimos.fr/?boot");

export default function App() {
	const { token } = useToken();

	const storage = new Storage();
	const { account, setSettings, getSettings } = useAccount();

	const [isInitialized, setInitialized] = useState(false);

	const { device, pwa, browser } = getDeviceInfo(new UAParser());
	const deferredPrompt = useRef(null);
	
useEffect(() => {
		const hasLogged = sessionStorage.getItem("connectionLogged");
		if (!hasLogged && token && account.employeeId) {
			const logRequest = {
				browser: `${browser?.name?.toLowerCase()}_${browser?.version?.toLowerCase()}`,
				origin: device.isMobile ? 1 : 0,
			};
			genRequest("stats/log-connection", logRequest, "post").catch(() => {});
			sessionStorage.setItem("connectionLogged", "true");
		}
	}, [account.employeeId, token]);

	const appInstalled = () => {
		localStorage.setItem(INSTALLATION_STATUS, INSTALLATION_MESSAGE);
		deferredPrompt.current = null;
	};
	const doNotShowAgain = (close) => {
		appInstalled();
		close();
	};
	const onInstall = (close) => {
		if (deferredPrompt.current) {
			deferredPrompt?.current.prompt();
			// Remember the install once the user has accepted it
			deferredPrompt.current.userChoice.then((choiceResult) => {
				if (choiceResult.outcome === "accepted") appInstalled();
			});
			close();
		}
	};

	const loadOneSignal = async () => {
		const appId = import.meta.env.VITE_ONESIGNAL_APP_ID;
		if (!appId) return;
		// One service worker per scope: the PWA worker (src/sw.js, registered by
		// vite-plugin-pwa at "/") already importScripts the OneSignal SDK worker,
		// so OneSignal reuses it instead of registering OneSignalSDKWorker.js
		OneSignal.init({
			appId,
			serviceWorkerPath: "sw.js",
			serviceWorkerParam: { scope: "/" },
		}).then(() => {
			OneSignal.Slidedown.promptPush();
		});
		OneSignal.Notifications.addEventListener(
			"permissionChange",
			(IsUserValidated) => {
				if (IsUserValidated) {
					OneSignal.login(account?.aspNetUserId)
						.then(() => {})
						.catch((error) => {
							// silently ignored
						});
				} else {
					// OneSignal SDK v16 throws internally when logout runs
					// before init completes — swallow.
					try {
						OneSignal.logout();
					} catch (e) {}
				}
			}
		);

		OneSignal.Notifications.addEventListener(
			"foregroundWillDisplay",
			(event) => {
				const targetPage =
					event?.notification?.additionalData?.TargetPage;
				// alert(JSON.stringify(event?.notification?.additionalData));
				if (targetPage) {
					if (targetPage === "OpenPostPage") {
						// The API (as v1) sends RedirectLink, capitalised
						window.location.href =
							event?.notification?.additionalData.RedirectLink;
					} else {
						window.location.href = RedirectNotifs[targetPage];
					}
					// window.location.href = targetPage;
				}
			}
		);
	};

	useMondayPwaTracker(account);

	useEffect(() => {
		if (token && account?.aspNetUserId && !isInitialized) {
			loadOneSignal();
		}
	}, [token, account?.aspNetUserId]);

	// PWA Installation Prompt

	useEffect(() => {
		const handleBeforeInstall = (e) => {
			e.preventDefault();
			deferredPrompt.current = e;
		};
		window.addEventListener(BEFORE_INSTALL_PROMPT, handleBeforeInstall);
		window.addEventListener(APP_INSTALLED, appInstalled);
		return () => {
			window.removeEventListener(
				BEFORE_INSTALL_PROMPT,
				handleBeforeInstall
			);
			window.removeEventListener(APP_INSTALLED, appInstalled);
		};
	}, []);

	useEffect(() => {
		const isIosStandalone = window.navigator.standalone === true;

		const isInstallable =
			device.isMobile || (device.isMobile && !pwa.isStandalone(window));
		const isInstalled = localStorage.getItem(INSTALLATION_STATUS);
		setTimeout(() => {
			if (!isIosStandalone) {
				if (isInstallable && !isInstalled)
					if (deferredPrompt.current) {
						installationPrompt({
							doNotShowAgain,
							onInstall,
						});
					} else {
						manualPrompt({
							doNotShowAgain,
							isIOS: device.isIOS,
							isAndroid: device.isAndroid,
						});
					}
			}
		}, 1e3);
	}, [device.isAndroid, device.isIOS]);

	const [langCode, setLang] = useState(getNavigatorLanguage());
	useEditing(false);

	function changeLang(code) {
		if (account?.companyId) setSettings("Language", code);
		else {
			localStorage.setItem("lang-code", code);
			window.location.reload();
		}
	}

	function getNavigatorLanguage() {
		let lang = navigator.language || navigator.userLanguage;

		if (account) {
			let from_settings = getSettings("Language");
			if (from_settings) return from_settings;
		}
		let from_local = localStorage.getItem("lang-code");
		if (from_local) return from_local;
		if (!lang) return "en-EN";
		if (lang.indexOf("-") === -1) lang = lang + "-" + lang.toUpperCase();
		return lang;
	}

	const get_load_img = () => storage.getItem("comp_image");

	// the reset link must open the form even if another session is still open
	// (30-day token): it is the only public route served to a logged-in user
	const isResetRoute = window.location.pathname === "/reset-password";

	if (!token || isResetRoute)
		return (
			<Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
				<Routes>
					{/* <Route path="/create" element={<CreatePage setLangCode={setLang}/>} /> */}
					<Route path="/forget" element={<ForgetPage setLangCode={setLang} />} />
					<Route path="/reset-password" element={<ResetPasswordPage setLangCode={setLang} />} />
					<Route path="/:accountId" element={<LoginPage setLangCode={setLang} />} />
					<Route path="*" element={<LoginPage setLangCode={setLang} />} />
				</Routes>
			</Router>
		);

	return (
		<AccountProvider>
			<PostProvider>
				<FilterProvider>
					{/* <ReactPWAInstallProvider enableLogging> */}
					<div
						ref={(ref) => ReactModal.setAppElement(ref)}
						className="wrapper"
						style={
							get_load_img()?.urlOrigin
								? { backgroundImage: `url(${get_load_img().urlOrigin})` }
								: undefined
						}
					>
						<ToastContainer
							position="top-right"
							autoClose={2000}
							hideProgressBar={false}
							newestOnTop={false}
							closeOnClick={true}
							rtl={false}
							pauseOnFocusLoss
							draggable
							pauseOnHover
						/>
						<BrainWrapper
							code={langCode}
							setLangCode={changeLang}
							// getMenuItems={getMenuItems}
							// getMenuItem={getMenuItem}
						/>
					</div>
					{/* </ReactPWAInstallProvider> */}
				</FilterProvider>
			</PostProvider>
		</AccountProvider>
	);
}
